// extracted by mini-css-extract-plugin
export default {"container":"MainPage_container__TtWet"};